import React from "react";
import LoadingView from "@/components/ui/loading-view/LoadingView";

const SubscriptionCenterView = React.lazy(
  () => import("./SubscriptionCenter.view")
);

const SubscriptionCenterLoadable = () => (
  <React.Suspense fallback={<LoadingView />}>
    <SubscriptionCenterView />
  </React.Suspense>
);

export default () => <SubscriptionCenterLoadable />;
